/**
 * Convert RGB array to hex color string
 */
export const rgbToHex = (rgb: number[]): string => {
  return '#' + rgb.map(c => Math.round(c).toString(16).padStart(2, '0')).join('');
};

/**
 * Replace {{color}} placeholders in SVG with actual hex color
 */
export const processSvgColor = (svg: string | undefined, color: number[]): string => {
  if (!svg) return '';
  return svg.replace(/\{\{color\}\}/g, rgbToHex(color));
};

export const wrapIconifyPath = (iconData: any) => {
  // Use iconData's width/height or default to 16 if not provided by Iconify
  const sourceWidth = iconData.width || 16;
  const sourceHeight = iconData.height || 16;
  const body = iconData.body;

  const targetSize = 85;
  const scale = targetSize / Math.max(sourceWidth, sourceHeight);
  
  const xOffset = (100 - sourceWidth * scale) / 2;
  const yOffset = (100 - sourceHeight * scale) / 2;

  return `<g transform="translate(${xOffset}, ${yOffset}) scale(${scale})">
  ${body}
</g>`;
};

interface CreateSvgIconOptions {
  svg: string | undefined;
  size?: number;
  color: [number, number, number];
  backgroundColor: [number, number, number];
}

/**
 * Create a complete SVG element with background and icon
 * @param options.svg - The SVG content (inner elements)
 * @param options.size - Size in pixels (default: 14)
 * @param options.color - RGB color array for the icon
 * @param options.backgroundColor - RGB color array for background
 * @returns Complete SVG string
 */
export const createSvgIcon = ({ 
  svg, 
  size = 14, 
  color, 
  backgroundColor,
}: CreateSvgIconOptions): string => {
  if (!svg) return '';
  
  const processedSvg = processSvgColor(svg, color);
  
  return `<svg width="${size}" height="${size}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" rx="14" ry="14" fill="${rgbToHex(backgroundColor)}" />
    <g>${processedSvg}</g>
  </svg>`;
};
